import React, { useState, useEffect } from "react"; 

import * as apiUrl from "../../apiUrl";

function CareerParallax() {
  const [CareerParallax, setCareerParallax] = useState([]);

  useEffect(() => {
    const fetchCareerParallax = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/last-image-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCareerParallax(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCareerParallax();
  }, []);

  return (
    <div className="about-parallax-sec">
      <img
        src={`${apiUrl.apiUrl}/${CareerParallax.last_image}`}
        className="img-fluid"
        alt="Marquis Developers Careers"
        data-aos="fade-up"
      />
    </div>
  );
}

export default CareerParallax;
